import { Component,ElementRef,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,Slides,Events,Platform,AlertController } from 'ionic-angular';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import { MenuController } from 'ionic-angular';
import { Storagehelper } from '../../providers/storagehelper'
import { Commontask } from '../../providers/commontask'
declare var AudioContext:any;
declare var webkitAudioContext:any;
declare var document;
import { Filetransfer} from '../../providers/filetransfer'
import { MediaPlugin, MediaObject } from '@ionic-native/media';
import { SocialSharing } from '@ionic-native/social-sharing';
/**
 * Generated class for the PageAudio page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-page-audio',
  templateUrl: 'page-audio.html',
})
export class PageAudio extends Commontask {
	@ViewChild(Slides) slides: Slides;
 	@ViewChild('ioncontent') ioncontent: ElementRef;
 	@ViewChild('detailPage') dataContainer: ElementRef;
	private pageid;
	public pageDetail;
	public bgImage;
	private loading;
	public slideIndex;
	public removebckbutton;
	public isdownloadedplaying;
	public currentdownloadedDurationsec;
	public audioplayer;
	public currentTime;
  	public progressTimer;
  	public downloadedInDate;
  	public extraClassOnBtn;
  	public progressInDate;
  	public isFavorite;
  	private downloadComplete;
  	public file: MediaObject;
  	public bckclass; 
  	public categoryID;
  	public soundFileFound;
  	public audioPlayError;
  	public onStatusUpdate = (status) => {console.log(status)};
	public onSuccess = () => console.log('Action is successful.');
	public onError = (error) => {
		console.error(error.message);
		this.isdownloadedplaying=false;
	};
	private onlineUrl;
	constructor(public navCtrl: NavController,public event:Events, public navParams: NavParams,public storage: Storagehelper,public loader:LoadingController,public menuctrl:MenuController,public sanitizer:DomSanitizer,public filetransfer:Filetransfer,private media: MediaPlugin,public platform:Platform,public socialShare:SocialSharing,public alertCtrl:AlertController) {
		super(menuctrl,event,platform,socialShare,alertCtrl);
		this.pageDetail={PageTitle:"",slidertasks:[],PageContent:"",bgImageUrl:"",localImageFile:"assets/images/c.png",Id:0};
		this.pageid=navParams.get('pageID');
		this.soundFileFound=true;
		this.audioPlayError=false;
		this.removebckbutton=navParams.get('removebckbutton');
		this.getPageDetail();
	  	this.loading=this.loader.create({
	      spinner:"ios",
	      cssClass:"dreamLoader"
	    });
	    this.extraClassOnBtn="";
	    // this.loading.present();
	    this.slideIndex=0;
	   	this.isdownloadedplaying=false;
		this.audioplayer=new Audio();
		this.currentTime=0;
		this.downloadedInDate="00:00";
		this.progressInDate="00:00";
		this.seekingTime=false;
		this.bckclass="";
		this.isFavorite=false;
		this.onlineUrl="";
		this.downloadComplete=false;
		this.categoryID=this.navParams.get("categoryID");
		this.getCategoryByCategoryID(storage,navParams);

		
	}
	bindAudioEvents(){
		console.log("Binding audio events");
		// this.audioplayer.onended(()=>{
		// 	console.log("audio has ended");
		// 	this.audioplayer.stop();
		// 	this.currentTime=0;
		// 	this.isdownloadedplaying=false;
		// 	clearInterval(this.progressTimer);
		// })
		this.audioplayer.addEventListener("ended", ()=>{
			console.log("audio has ended");
			this.audioplayer.pause();
			this.currentTime=0;
			this.isdownloadedplaying=false;
			clearInterval(this.progressTimer);
		});
	}

	subscribeEvent(){
		this.event.subscribe('app:audioDownloadProgress',(data)=>{
			if(data.url==this.onlineUrl){

			}
		})
		this.event.subscribe('app:downloadProgress',(data)=>{
			// if(data.status=="downloadError"){
			// 	this.audioPlayError=true;
			// 	this.isdownloadedplaying=false;
			// 	let alert=this.alertCtrl.create({
			// 	  			title:"Mitt lugn",
			// 	  			message:'Unable to download audio...',
			// 	  			buttons:[{
			// 	  				text:'OK',
			// 	  				role:'cancel'
			// 	  			}]
			// 	  		})
			// 	  		alert.present();
			// }
		})

		this.event.subscribe('app:pauseAudio',()=>{
			this.isdownloadedplaying=false;
			// this.file.pause();
			// this.file.stop();
		})
		this.event.subscribe('app:audioDownloadComplete',(data)=>{
			this.extraClassOnBtn="";
			console.log("Event received download complete");
			if(data.url==this.onlineUrl){
				this.downloadComplete=true;
				this._createAudio(data.localurl);                          
		        this.audioplayer.pause();        
		        this.audioplayer.src = data.localurl;
		        this.audioplayer.load();    
		        if(this.isdownloadedplaying==true){
		        	this.isdownloadedplaying=false;
	        		this.Play();
		        }
		           
		        this.bindAudioEvents(); 
			}
		})
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad PageAudio');
	}
	getPageDetail(){
		this.storage.queryStorage('pagelist','Id',this.pageid).then((data)=>{
			this.loading.dismiss();
			if(data.length>0){
				this.pageDetail=data[0];
				
				if(this.pageDetail.pagelinks.length>0){
					 this.pageDetail.pagelinks.map((e,i)=>{
					 	e.categoryid=this.navParams.get("categoryID");
					 })
				}
	     		// this.dataContainer.nativeElement.innerHTML = this.pageDetail.PageContent;
	     		if(this.pageDetail.backgroundType==1){
	     			if(this.pageDetail.bgImageUrl!="")	{	
		     			// var localCheck=this.checkIfBackgroundStatic(this.pageDetail.bgImageUrl);
		     			// if(localCheck!=false){
							// //this.loading.dismiss();
			     			// this.pageDetail.localImageFile=localurl;
			     			//Using javascript to set page background
			     			// document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('../assets/images/"+localCheck+".png')"
				     		// this.bckclass=localCheck;
		     			// }else{
		     				// //this.loading.dismiss();
				     		this.filetransfer.saveFileLocally(this.pageDetail.bgImageUrl,"images").then((localurl)=>{
				     			
				     			this.pageDetail.localImageFile=localurl;
				     			//Using javascript to set page background
				     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
				     		
				     		},(err)=>{
									////this.loading.dismiss();
				     			if(err=="browser"){
				     				this.pageDetail.localImageFile = this.pageDetail.bgImageUrl;
				     				//Using javascript to set page background
				     				document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
				     			}
				     		});
		     			// }

		     		}else{
						//this.loading.dismiss();
		     		}
	     		}else{
	     			////this.loading.dismiss();
	     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundColor="#"+this.pageDetail.backgroundColor;
				     				document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="unset";
	     		}
	     		
	     		this.initiateAudioPlayer();
	     		this.checkFavorite();
			}
		})
	}


	pauseAudio(){
		this.isdownloadedplaying=false;
	}

	_createAudio(audiourl): void{
        if(!this.file && this.isDevice()){                     
            var self=this;
            this.file=this.media.create(audiourl.replace(/^file:\/\//, '') , ()=>{ },  ()=>{
            	// this.event.publish("app:pauseAudio");
            	self.isdownloadedplaying=false;
            },  this.onError);                                    
        } else if(!this.isDevice){
        	this.audioplayer = new Audio();   
        	this.audioplayer.src=audiourl;
	        this.audioplayer.load();  
            this.audioplayer.autoplay = false;
            this.audioplayer.preload = 'auto';
            this.audioplayer.autobuffer = true; 
        }     
    }
    getAudioPlayerProgress(){
    	this.progressTimer=setInterval(()=>{
    		// this.audioplayer.getCurrentPosition((position)=>{
    		// 		this.currentTime=Math.round(position);
    		// })
    			// console.log(this.audioplayer.currentTime);
    			if(this.isdownloadedplaying==false){
    				clearInterval(this.progressTimer);
    				this.isdownloadedplaying=false;
    				if(this.file!=undefined)
	    				this.file.stop();
    				this.currentTime=0;
    				this.progressInDate="00:00";
    			}
    			if(this.isdownloadedplaying==true){
    				if(this.isDevice()){
		    			this.file.getCurrentPosition().then((position) => {
						  	this.currentTime=position;
			    			var minutes = Math.floor(this.currentTime / 60);
			    			var seconds = Math.floor(this.currentTime - minutes * 60);
			    			if(minutes==-1){
			    				this.progressInDate="00:00";
			    			}else{
								this.progressInDate=((minutes <10) ? "0"+minutes : minutes)+":"+((seconds <10) ? "0"+seconds : seconds);
			    			}
							this.currentdownloadedDurationsec=this.file.getDuration();
			    			var minutes = Math.floor(this.currentdownloadedDurationsec / 60);
			    			var seconds = Math.floor(this.currentdownloadedDurationsec - minutes * 60);
							this.downloadedInDate=((minutes <10) ? "0"+minutes : minutes)+":"+((seconds <10) ? "0"+seconds : seconds);
						});
	    			}else{
	    				this.currentTime=this.audioplayer.currentTime;
	    				var minutes = Math.floor(this.currentTime / 60);
			    			var seconds = Math.floor(this.currentTime - minutes * 60);
			    			if(minutes==-1){
			    				this.progressInDate="00:00";
			    			}else{
								this.progressInDate=((minutes <10) ? "0"+minutes : minutes)+":"+((seconds <10) ? "0"+seconds : seconds);
			    			}
							this.currentdownloadedDurationsec=this.audioplayer.duration;
			    			var minutes = Math.floor(this.currentdownloadedDurationsec / 60);
			    			var seconds = Math.floor(this.currentdownloadedDurationsec - minutes * 60);
							this.downloadedInDate=((minutes <10) ? "0"+minutes : minutes)+":"+((seconds <10) ? "0"+seconds : seconds);
	    			}
    			}
    			
    	},1000)
    }
    
    _destroyAudio(): void{        
        if(this.audioplayer){
            this.audioplayer.pause();
            this.audioplayer.unbindEvents();
            try {
                this.audioplayer.src = '';
            } finally {
                delete this.audioplayer;
            }
        }
    }       
    mediaPlayComplete(){
    	console.log("audio has ended");
		this.isdownloadedplaying=false;
  //   	if(this.audioplayer)
		// 	this.audioplayer.pause();
		// if(this.file){
		// 	this.file.pause();
		// 	this.file.stop();
		// }
		// // this.currentTime=0;
		// clearInterval(this.progressTimer);
		// this.file.stop();
		this.progressInDate="00:00";
    }
	initiateAudioPlayer(){
		var audioUrl=this.pageDetail.SoundUrl;
		if(audioUrl!=""){
			this.onlineUrl=audioUrl;

			this.filetransfer.saveFileLocally(this.pageDetail.SoundUrl,"audio").then((localurl)=>{
	     			
					this.extraClassOnBtn="";
				 	this._createAudio(localurl);  
			         this.downloadComplete=true;  
			        // this.Play();   
			        this.bindAudioEvents();     
     		},(err)=>{
					//this.loading.dismiss();
     			if(err=="browser"){

					this.extraClassOnBtn="";
     				console.log("you are using browser");
				 	this._createAudio(audioUrl);                          
			        this.audioplayer.pause();        
			        this.audioplayer.src = audioUrl;
			        this.audioplayer.load();  
			        // this.Play(); 
			        this.bindAudioEvents();   
			        this.downloadComplete=true; 
     			}else{
     // 				this.audioPlayError=true;
					// this.isdownloadedplaying=false;
					// let alert=this.alertCtrl.create({
					//   			title:"Mitt lugn",
					//   			message:'Det går inte att ladda ner ljud!',
					//   			buttons:[{
					//   				text:'OK',
					//   				role:'cancel'
					//   			}]
					//   		})
					//   		alert.present();
     			}
     		});
		}else{
			this.soundFileFound=false;
	  		
		}
	}

	soundNotFound(){
		let alert=this.alertCtrl.create({
	  			title:this.alertTitle,
	  			message:'Ingen ljudfil',
	  			buttons:[{
	  				text:'OK',
	  				role:'cancel'
	  			}]
	  		})
	  		alert.present();
	}

	ionViewWillLeave(){
		this.Pause();
		this.isdownloadedplaying=false;


		this.event.unsubscribe("app:audioDownloadProgress");
		this.event.unsubscribe("app:downloadProgress");
		this.event.unsubscribe("app:pauseAudio");
		this.event.unsubscribe("app:audioDownloadComplete");

	}
	ionViewDidEnter(){
		// if(this.audioplayer.src!=""){
		// 	this.Play();
		// }
		this.checkFavorite();

		this.subscribeEvent();
	}
	 Play(){
	 	if(this.audioPlayError==true){
	 		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Det går inte att ladda ner ljud!',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
	  		alert.present();
	  		return;
	 	}
	 		if(this.pageDetail.SoundUrl==""){
	 			this.soundNotFound();
	 		}else{

			 	if(this.isdownloadedplaying==false){
			        // this.audioplayer.play();
			        if(this.downloadComplete==true){
			        	if(this.isDevice()){
				        	this.file.play();
			        	}else{
			        		this.audioplayer.play();
			        	}
			        	this.getAudioPlayerProgress();
			        }else{

	    				this.extraClassOnBtn="button-spin";
			        }
				   	this.isdownloadedplaying=true;
				   	let self=this;
				   
			 	}else{
			 		if(this.progressTimer)
				 		clearInterval(this.progressTimer);
			        this.Stop();
				   	this.isdownloadedplaying=false;
			 	}
	 		}	
        // Comment visuliziation out for now.
        // this.Visualize();
    }
    
    Pause(){
        // this.audioplayer.pause();
        if(this.file)
	        this.file.pause();
	    if(this.audioplayer)
	        this.audioplayer.pause();
    }
    
    Stop(){
        // this.audioplayer.pause();
        if(this.file)
	        this.file.pause();
	    if(this.audioplayer)
	        this.audioplayer.pause();
    }
    public seekingTime;
    sliderRelease(){
    	this.audioplayer.currentTime=this.currentTime;
    	let seekdedtime=this.currentTime;
    	console.log(seekdedtime);
    	if(this.isDevice()){
	    	this.file.getCurrentPosition().then((position) => {
	    			if(Math.floor(position)!=Math.floor(seekdedtime) && Math.floor(position)!=(Math.floor(seekdedtime)+1) &&  Math.floor(position)!=(Math.floor(seekdedtime)-1) ){
	    				this.file.seekTo((seekdedtime*1000)); //Seek time in ms
	    			}
	    	});
    	}else{
    		// this.audioplayer.currentTime=this.currentTime
    	}
    }

    public makeTaskFav(){
    	// this.storage.setStorageItem('favorite')
    	if(!this.isFavorite){
	    	this.storage.deleteItem('favoriteTasks','Id',this.pageDetail.Id).then(()=>{
	    		this.pageDetail.categoryid=this.categoryDetail.category_id;
	    		this.storage.addNewItem('favoriteTasks','FavoriteId',this.pageDetail).then(()=>{
	    			this.isFavorite=true;

				  		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Sparat i menyn under favoriter',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
				  		alert.present();
    				this.event.publish("app:loadFavoriteItems");
	    		})
	    			
	    	})
    	}else{
    		this.storage.deleteItem('favoriteTasks','Id',this.pageDetail.Id).then(()=>{
	    			this.isFavorite=false;

				  		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Borttaget som favorit i menyn ',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
				  		alert.present();
    				this.event.publish("app:loadFavoriteItems");
	    	})
    	}
    }

    private checkFavorite(){
    	this.storage.queryStorage('favoriteTasks','Id',this.pageDetail.Id).then((data)=>{
    		if(data!=null && data.length>0){
    			this.isFavorite=true;
    		}
    	})
    }
}


// WEBPACK FOOTER //
// ./src/pages/page-audio/page-audio.ts